<template>
  <el-form class="search-style">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-form-item>
          <el-select v-model="queryParams.column" @change="clearParams">
            <el-option
              v-for="(item, index) in columnOption"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4" v-show="expressionArray.includes(queryParams.column)">
        <el-form-item>
          <el-select v-model="params.expression">
            <el-option
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
              v-for="(item, index) in expressionList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item v-show="selectArray.includes(queryParams.column)">
          <el-select v-model="params.value">
            <el-option
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
              v-for="(item, index) in valueOptionArray"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="!timerArray.includes(queryParams.column) && !selectArray.includes(queryParams.column)"
        >
          <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item v-show="timerArray.includes(queryParams.column)">
          <el-date-picker
            v-model="paramsTimer"
            style="width:100%;"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm"
            :default-time="['00:00:00','23:59:59']"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
          <el-button @click="searchReset">重置</el-button>
        </el-form-item>
      </el-col>
       <el-col v-if="$route.name ==='haveDebt'" :span="10" style='text-align:right'>
          <el-button @click='toExport'>导出清单</el-button>
      </el-col>
      <!-- <slot name="before"></slot> -->
      <slot></slot>
    </el-row>
  </el-form>
</template>

<script>
import { expressionList } from '@/components/utils/data'
import { getComAll, exportArrearsCustomers } from '@/api/fiance/fianceManage'
import { isSuccess, downLoadFileBlob } from '@/util/tool'
import { cPayType } from '@/views/finance/financeManage/util/data'
import { cloneDeep } from 'loadsh'

export default {
  name: 'financeSearch',
  props: {
    columnOption: {
      type: Array,
      default: () => []
    },
    valueOption: {
      type: Array,
      default: () => []
    },
    timerArray: {
      type: Array,
      default: () => ['createDate', 'processDate', 'invoiceReceiveDate']
    },
    expressionArray: {
      type: Array,
      default: () => ['payAmount', 'amount']
    },
    selectArray: {
      type: Array,
      default: () => [
        'payType',
        'invoiceType',
        'orgName',
        'fromType',
        'billState',
        'invoiceState',
        'cstate'
      ]
    }
  },
  watch: {
    'queryParams.column': {
      handler (newVal) {
        switch (newVal) {
          case 'invoiceType':
            this.valueOptionArray = cloneDeep(this.invoiceType)
            break
          case 'orgName':
            this.valueOptionArray = cloneDeep(
              this.orgList.map((item) => {
                return Object.assign(item, {
                  label: item.orgName,
                  value: item.orgName
                })
              })
            )
            break
          case 'payType':
            this.valueOptionArray = cloneDeep(this.cPayType)
            break
          case 'billState':
            // 1 未使用 2 已使用 3 已贴现 4 已作废
            this.valueOptionArray = [
              {
                label: '未使用',
                value: 1
              },
              {
                label: '已使用',
                value: 2
              },
              {
                label: '已贴现',
                value: 3
              },
              {
                label: '已作废',
                value: 4
              }
            ]
            break
          case 'fromType':
            this.valueOptionArray = [
              {
                label: '后台添加',
                value: 1
              },
              {
                label: '收款申请',
                value: 2
              }
            ]
            break
          case 'type':
            this.valueOptionArray = [
              {
                label: '开票退票',
                value: '开票退票'
              },
              {
                label: '收票退票',
                value: '收票退票'
              }
            ]
            break
          case 'state':
            this.valueOptionArray = [
              {
                label: '已退票',
                value: 4
              },
              {
                label: '审核不通过',
                value: 3
              }
            ]
            break
          case 'cstate':
            this.valueOptionArray = [
              // {
              //   label: '收款审核',
              //   value: 1
              // },
              {
                label: '收款成功',
                value: 2
              },
              {
                label: '收款审核不通过',
                value: 3
              }
            ]
            break
          case 'invoiceState':
            this.valueOptionArray = [
              {
                label: '未收票',
                value: 1
              },
              {
                label: '已收票',
                value: 2
              },
              {
                label: '审核不通过',
                value: 3
              }
            ]
            break
        }
        return newVal
      },
      deep: true
    }
  },
  data () {
    return {
      searchList: [],
      queryParams: {
        column: ''
      },
      params: {
        value: '',
        expression: ''
      },
      paramsTimer: '',
      expressionList,
      cPayType,
      orgList: [],
      invoiceType: [
        {
          label: '普通发票',
          value: '普通发票'
        },
        {
          label: '专用发票',
          value: '专用发票'
        }
      ],
      valueOptionArray: []
    }
  },
  mounted () {
    this.innerInit()
    this.getOrgList()
  },
  methods: {
    // 导出清单
    toExport() {
      const obj = {
        invoicePayUrl: this.$store.state.arrearsCustomersUrl,
        queryCriteriaVo: {
          criteriaVoList: this.searchList,
          queryPageName: ''
        },
        type: 0
      }
      exportArrearsCustomers(obj).then(res => {
        downLoadFileBlob(this, res)
      })
    },
    getOrgList () {
      getComAll().then(res => {
        if (isSuccess(res)) {
          this.orgList = res.data.obj && res.data.obj.filter(item => item.orgFatherId !== 0)
        }
      })
    },
    clearParams () {
      this.params = {}
      this.paramsTimer = ''
      if (this.expressionArray.includes(this.queryParams.column)) {
        this.$set(this.params, 'expression', 'eq')
      }
    },
    onSearch () {
      const { queryParams, params, paramsTimer, timerArray } = this
      if (timerArray.includes(queryParams.column)) {
        params.value = paramsTimer[0]
        params.endValue = paramsTimer[1]
      }
      if (!params.value && params.value !== 0) {
        this.$message.error('请输入搜索条件')
        return
      } else if (!queryParams.column && queryParams.column !== 0) {
        this.$message.error('请选择搜索选项')
        return
      }
      const list = this.$queryParams(queryParams, params)
      this.searchList = list
      this.$emit('onSearch', list)
    },
    searchReset () {
      this.params = {}
      this.queryParams = {}
      this.$emit('onSearch', [])
    },
    innerInit () {
      this.queryParams = {
        column: ''
      }
      this.params = {
        value: '',
        expression: ''
      }
      this.paramsTimer = ''
    }
  }
}
</script>
